// src/api/devNotes.js
import api from "./api"; // your existing API wrapper

export const DevNotesAPI = {
  list(params = {}) {
    const query = new URLSearchParams(params).toString();
    const qs = query ? `?${query}` : "";
    return api(`/dev-notes${qs}`);
  },

  create(data) {
    return api("/dev-notes", {
      method: "POST",
      body: JSON.stringify(data),
    });
  },

  update(id, data) {
    return api(`/dev-notes/${id}`, {
      method: "PATCH",
      body: JSON.stringify(data),
    });
  },

  delete(id) {
    return api(`/dev-notes/${id}`, {
      method: "DELETE",
    });
  },
};
